import Container from './StudioTableDesktop.container';
import StudioTableDesktop from './StudioTableDesktop';

export default Container(StudioTableDesktop);
